import { Injectable } from '@angular/core';
import { Breadcrumb } from '../../@types/Breadcrumb';
import { BehaviorSubject, filter } from 'rxjs';
import { ActivatedRouteSnapshot, Data, NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbService {

  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs: Breadcrumb[] = [];
      this.addBreadcrumb(root, [], breadcrumbs);
      this._breadcrumbs$.next(breadcrumbs);
    });
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot | null, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    if (!route) return;

    const routeUrl = parentUrl.concat(route.url.map(url => url.path));

    
    if (route.data['breadcrumb']) {
      const breadcrumb: Breadcrumb = {
        label: this.getLabel(route.data),
        url: '/' + routeUrl.join('/')
      };
      breadcrumbs.push(breadcrumb);
    }

    this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
  }

  private getLabel(data: any) {
    return typeof data['breadcrumb'] === 'function' ? data['breadcrumb'](data) : data['breadcrumb'];
  }

}
